module.exports = __webpack_public_path__ + "img/arrow-2.d5d16408.png";